import Header from "@/components/Header";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

const Impressum = () => (
  <>
    <SEOHead title="Impressum – Leadership Focus GmbH" description="Impressum der Leadership Focus GmbH, Leopoldstr. 77, 80802 München. Angaben gemäß § 5 TMG." canonical="https://leadership-focus.de/impressum" />
    <Header />
    <main className="container py-20 min-h-[60vh] max-w-3xl">
      <h1 className="text-4xl font-serif font-bold text-foreground mb-8">Impressum</h1>

      <section className="space-y-6 text-foreground/90 leading-relaxed">
        <div>
          <h2 className="text-xl font-semibold mb-2">Angaben gemäß § 5 TMG:</h2>
          <p>Leadership Focus GmbH<br />Leopoldstr. 77<br />80802 München</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Vertreten durch:</h2>
          <p>Vertreten durch die Geschäftsführer:innen Dr. Margret Klinkhammer und Stephan Rathgeber</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Kontakt:</h2>
          <p>Telefon: +49 (0)151 - 22 63 53 61<br />E-Mail: kontakt(ät)leadership-focus.de</p>
          <p className="text-sm text-muted-foreground mt-1">
            Hinweis: Um Spam-E-Mails zu vermeiden, haben wir das „@" in unserer Mail-Adresse mit „(ät)" ersetzt. Bitte verwenden Sie stattdessen wieder das „@", wenn Sie uns kontaktieren möchten.
          </p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Registereintrag:</h2>
          <p>Eintragung im Handelsregister.<br />Registergericht: Amtsgericht München<br />Registernummer: HR B 176 462</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Umsatzsteuer:</h2>
          <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />DE 262776663</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Textbearbeitung:</h2>
          <p>Burkhard Rathgeber – Erlangen<br />Stephan Rathgeber – Erlangen<br />Dr. Margret Klinkhammer – München</p>
        </div>

        <div>
          <h2 className="text-xl font-semibold mb-2">Angaben zur Berufshaftpflichtversicherung</h2>
          <p>Die Haftpflichtversicherung besteht bei der ERGO Versicherung AG in 40198 Düsseldorf.</p>
          
        </div>


      </section>
    </main>
    <Footer />
  </>
);

export default Impressum;
